import React from 'react';
import { Block, BLOCKS, Inline, INLINES } from '@contentful/rich-text-types';

import { ISplitAssetWithTextFields } from '@/types/contentful';

import { getImageData } from '../../../utils/contentful';

import { Flexbox } from '../../Flexbox';
import { Box } from '../../Box';
import { Text } from '../../Text';
import RichText from '../../RichText';
import { EmbeddedInlineEntryNode } from '../../RichText/Nodes';

import { InlineAnchor } from '../../RichText/styles';
import { StyledImage } from './styles';

export function AssetWithText({
  asset,
  heading,
  body
}: ISplitAssetWithTextFields) {
  return (
    <Flexbox
      flexDirection="column"
      padding={{ 0: 'sm', tablet: 'm' }}
      margin={{ 0: 0, desktop: 'm' }}
      data-testid="split-module-asset-with-text"
    >
      <Box marginBottom="ml">
        <StyledImage
          {...getImageData(asset)}
          width={450}
          height={300}
          layout="responsive"
          objectFit="cover"
        />
      </Box>

      <Text
        as="h3"
        fontSize={{ 0: '2xl', desktop: '4xl' }}
        lineHeight={{ 0: 'l', desktop: '4xl' }}
        fontWeight="500"
        padding={{ 0: ['s', 'l'], desktop: ['s', 'm'] }}
      >
        {heading}
      </Text>

      {body && (
        <Flexbox padding={{ 0: ['s', 'l'], desktop: ['s', 'm'] }}>
          <RichText
            data={body}
            overrideOptions={{
              [BLOCKS.PARAGRAPH]: (_node: Block | Inline, children) => (
                <Text
                  as="p"
                  fontWeight="p"
                  fontSize={{ 0: 's', desktop: 'm' }}
                  lineHeight={{ 0: 'smm', desktop: 'ml' }}
                  colour="defaultText"
                >
                  {children}
                </Text>
              ),
              [INLINES.HYPERLINK]: (node, children) => (
                <InlineAnchor href={node.data.uri} colour="defaultText">
                  {children}
                </InlineAnchor>
              ),
              [INLINES.EMBEDDED_ENTRY]: (node, children) => (
                <EmbeddedInlineEntryNode
                  node={node}
                  colour="defaultText"
                  fontWeight="p"
                >
                  {children}
                </EmbeddedInlineEntryNode>
              )
            }}
          />
        </Flexbox>
      )}
    </Flexbox>
  );
}
